// removed by extract-text-webpack-plugin
module.exports = {"component":"_3rAeqL3ZVByegl1dCe1C_N","box":"XHG7N_rN6V27kn13ogeql","checkmark":"_3cDMcwQBq3wDN9GkmU1l9w","checked":"_4Kcdhwm7w9rZD4y9tEKc-","hiddenInput":"scKBMCwA1FxoJjVrpURZB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.css
// module id = 1284
// module chunks = 0